import React, { useState, useEffect } from "react";
import { flatten, pipe } from "ramda";
import { useNavigate, useLocation } from "react-router-dom";
import { deduplicate } from "../../../../util/mediaUtil";

import ListSummaryCard from "../../../common/ListSummaryCard";
import IncludedInMenu from "../../common/IncludedInMenu";

const ContentParentsCard = props => {
  const { content, setLoading } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [parents, setParents] = useState([]);
  useEffect(() => {
    const parents = pipe(
      flatten,
      deduplicate,
    )([content.parentModules, content.parentCollections]);
    setParents(parents);
  }, [navigate, location, content.parentModules, content.parentCollections]);

  return (
    <ListSummaryCard
      data={parents}
      renderPopover={({ ...popoverProps }) => (
        <IncludedInMenu
          {...popoverProps}
          parents={parents}
          child={content}
          setLoading={setLoading}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        />
      )}
    />
  );
};

export default ContentParentsCard;
